export default {
	title: '無効化された要素',
	empty: 'このシナリオに無効化された要素はありません',
	no_scenario: 'シナリオを選択すると無効化された要素が表示されます'
};
